async function fetchMapData(mapElement, mapJsonDataURL) {
	if (!mapJsonDataURL) {
		console.warn('No data-map-url found on map');
		return null;
	}

	try {
		const response = await fetch(mapJsonDataURL);
		if (!response.ok) {
			throw new Error(`Network response was not ok (${response.status})`);
		}
		return await response.json();
	} catch (error) {
		console.error('Failed to fetch or parse JSON:', error);
		return null;
	}
}

async function runPassRateScript(mapJsonDataURL) {
	const maps = document.querySelectorAll('.mod-interactive-map');

	for (const map of maps) {
		const data = await fetchMapData(map, mapJsonDataURL);
		if (!data) continue;

		// === Step 1: Extract threshold values from legend ===
		const legend = data.legend || {};
		const lowValue = parseFloat(legend['low-pass']?.value);
		const highValue = parseFloat(legend['high-pass']?.value);

		// Validation
		if (isNaN(lowValue) || isNaN(highValue)) {
			console.warn('Skipping map — missing or invalid legend threshold values.');
			continue;
		}

		// === Step 2: Build colourMap by evaluating passRate values ===
		const colourMap = {};
		for (const [regionKey, regionData] of Object.entries(data)) {
			if (regionKey === 'legend') continue;

			const passRateStr = regionData?.passRate?.value;
			const numericRate = parseFloat(passRateStr?.replace('%', ''));

			if (isNaN(numericRate)) continue;

			let className = '';
			if (numericRate < lowValue) {
				className = 'low-pass';
			} else if (numericRate > highValue) {
				className = 'high-pass';
			} else {
				className = 'med-pass';
			}

			colourMap[regionKey] = className;
		}

		if (Object.keys(colourMap).length === 0) {
			console.log('Skipping map — no region classification possible');
			continue;
		}

		// === Step 3: Generate legend if needed ===
		function createPassRateKeyFromJSON(legendData, map) {
			const innerContainer = map.querySelector('.mod-interactive-map__inner-container');
			if (!innerContainer) return;

			// Avoid duplicate legends
			if (innerContainer.querySelector('.pass-rate-key')) return;

			const keyContainer = document.createElement('div');
			keyContainer.className = 'pass-rate-key';

			Object.entries(legendData).forEach(([key, entry]) => {
				const keyItem = document.createElement('div');
				keyItem.className = 'key-item';

				const colorBox = document.createElement('span');
				colorBox.className = 'color-box';
				colorBox.style.backgroundColor = entry.color || '#ccc'; // fallback color

				const label = document.createElement('span');
				label.textContent = entry.label;

				keyItem.appendChild(colorBox);
				keyItem.appendChild(label);
				keyContainer.appendChild(keyItem);
			});

			innerContainer.appendChild(keyContainer);
		}

		if (data.legend) {
			// Ensure each legend entry has a class for color-box styling
			Object.entries(data.legend).forEach(([key, entry]) => {
				if (!entry.class) {
					entry.class = key;
				}
			});

			createPassRateKeyFromJSON(data.legend, map);
		}

		// === Step 4: Apply classes to regions ===
		Object.entries(colourMap).forEach(([regionKey, className]) => {
			if (!className) return;

			let selector = `[data-map-id-region="${regionKey}"]`;
			let paths = map.querySelectorAll(selector);

			if (paths.length === 0) {
				selector = `[data-map-id-country="${regionKey}"]`;
				paths = map.querySelectorAll(selector);
			}

			paths.forEach(path => path.classList.add(className));
		});
	}
}

// // Run the script after DOM is ready
// document.addEventListener('DOMContentLoaded', () => {
//   runPassRateScript();
// });
